<template>
  <div class="cart-accessoires" :class="{'is-loading': products === null}" v-if="products && products.length > 0">
    <div class="cart-accessoires-wrapper">
      <div class="cart-accessoires-header">
        <h2 class="cart-accessoires-title">{{ Translator('front.cart.accessoires.title') }}</h2>
        <p class="cart-accessoires-txt">{{ Translator('front.cart.accessoires.description') }}</p>
      </div>

      <div class="cart-accessoires-list">
        <div class="accessoire" v-for="item in firstProducts" :key="item.id">
          <div class="accessoire-image" v-for="variant in item.variants" :key="variant.id">
            <img :src="variant.image.file.url" :alt="variant.name" v-if="variant.image && variant.image.file && variant.image.file.url">
          </div>

          <div class="accessoire-container">
            <div class="accessoire-content">
              <p class="accessoire-title" v-if="item.name">{{ item.name }}</p>
              <div class="accessoire-description" v-if="item.shortDescription" v-html="item.shortDescription"></div>
            </div>
            <div class="accessoire-actions-price" v-for="variant in item.variants" :key="variant.id">
              <p class="accessoire-price" v-if="variant.priceTtc && variant.onHand !== 0">
                <template v-if="displayedHt">{{ (variant.price /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                <template v-else>{{ (variant.priceTtc /100) | toFixed(2) }} €</template>
              </p>
              <p class="accessoire-price" v-else-if="variant.onHand === 0">{{ Translator('front.cart.accessoires.on_hand_empty') }}</p>
              <div class="accessoire-actions">
                <button type="button" class="accessoires-button" :class="{'is-loading': variant.isLoading }" :disabled="variant.isLoading || variant.onHand === 0" @click="onAddToCart(variant)" v-if="windowWidth >= 768">{{ Translator('front.cart.accessoires.add_to_cart')}}</button>
                <button type="button" class="accessoires-button" :class="{'is-loading': variant.isLoading }" :disabled="variant.isLoading || variant.onHand === 0" @click="onAddToCart(variant)" v-else-if="windowWidth < 768"><i class="ico ico-shopping"></i></button>
                <p class="accessoire-error" v-if="variant.error">{{ variant.error }}</p>
              </div>
            </div>
          </div>
        </div>

        <template v-if="lastProducts.length >= 1">
          <div class="cart-accessoire-more-action" v-if="windowWidth < 768">
            <button class="cart-accessoire-more-btn" v-if="isHidden" @click="isHidden = !isHidden">
              {{ Translator('front.cart.accessoires.display_more') }}
              <i class="ico ico-arrow-down"></i>
            </button>
            <button class="cart-accessoire-more-btn cart-accessoire-more-btn--arow-up" v-else-if="!isHidden" @click="isHidden = !isHidden">
              {{ Translator('front.cart.accessoires.display_less') }}
              <i class="ico ico-arrow-down"></i>
            </button>
          </div>
        </template>

        <template v-if="windowWidth >= 768 || !isHidden">
          <div class="accessoire" v-for="item in lastProducts" :key="item.id">
            <div class="accessoire-image" v-for="variant in item.variants" :key="variant.id">
              <img :src="variant.image.file.url" :alt="variant.name" v-if="variant.image && variant.image.file && variant.image.file.url">
            </div>

            <div class="accessoire-container">
              <div class="accessoire-content">
                <p class="accessoire-title" v-if="item.name">{{ item.name }}</p>
                <div class="accessoire-description" v-if="item.shortDescription" v-html="item.shortDescription"></div>
              </div>
              <div class="accessoire-actions-price" v-for="variant in item.variants" :key="variant.id">
                <p class="accessoire-price" v-if="variant.priceTtc && variant.onHand !== 0">
                  <template v-if="displayedHt">{{ (variant.price /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                  <template v-else>{{ (variant.priceTtc /100) | toFixed(2) }} €</template>
                </p>
                <p class="accessoire-price" v-else-if="variant.onHand === 0">{{ Translator('front.cart.accessoires.on_hand_empty') }}</p>
                <div class="accessoire-actions">
                  <button type="button" class="accessoires-button" :class="{'is-loading': variant.isLoading }" :disabled="variant.isLoading || variant.onHand === 0" @click="onAddToCart(variant)" v-if="windowWidth >= 768">{{ Translator('front.cart.accessoires.add_to_cart')}}</button>
                  <button type="button" class="accessoires-button" :class="{'is-loading': variant.isLoading }" :disabled="variant.isLoading || variant.onHand === 0" @click="onAddToCart(variant)" v-else-if="windowWidth < 768"><i class="ico ico-shopping"></i></button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

    </div>
  </div>
</template>
<script>
import OrdersService from '@/services/Orders';
import ProductsService from '@/services/Products';

export default {
  name: 'cart-accesoires',
  data () {
    return {
      cart: OrdersService.cart,
      products: null,
      variants: null,
      windowWidth: window.innerWidth,
      isHidden: true
    }
  },
  created() {
    window.addEventListener("resize", this.onResize);
    OrdersService.on('updated', this._onUpdateCart);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
    OrdersService.off('updated', this._onUpdateCart);
  },
  computed: {
    firstProducts() {
      return this.products.filter((product, index) => index < 2);
    },
    lastProducts() {
      return this.products.filter((product, index) => index >= 2);
    },
    displayedHt: function() {
      return this.cart?.displayedHt;
    }
  },
  beforeDestroy() {},
  mounted() {
    ProductsService.getAll({isEditable: false}).then( res => {
      this.products = res.data['hydra:member'];
      this.variants = [];
      this.products.forEach(product => {
        product.isLoading = false;
        product.variants.forEach( variant => {
          variant.isLoading = false;
          this.variants.push(variant);
        })
      });
    })
  },
  methods: {
    onAddToCart(item) {
      if(item.isLoading) return;
      item.isLoading = true;
      this.$forceUpdate();
      OrdersService.addItem({
        quantity: 1,
        variant: item['@id']
      }).then( () => {
        OrdersService.get();
      }).catch((err) => {
        item.isLoading = false;
        item.onHand = 0;
        item.error = err.response.data['hydra:description'];
        this.$forceUpdate();
      }).then( () => {
        item.isLoading = false;
        this.$forceUpdate();
      })
    },

    _onUpdateCart(res) {
      this.cart = res;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style scoped lang="scss">
  .cart-accessoires{
    &.is-loading {
      .cart-accessoires-list {
        @include loader;
      }
    }
  }
  .cart-accessoires-wrapper{
    background-color: transparent;
  }
  .cart-accessoires-header{
    margin-bottom: rem(18);
  }
  .cart-accessoires-title{
    @include title(3);
    margin-bottom: rem(6);
  }
  .cart-accessoires-txt{
    color: $grey;
    font-size: rem(14);
  }
  .cart-accessoires-list{}
  .accessoire{
    display: flex;
    background-color: $white;
    padding: rem(16) rem(24);
    margin-bottom: rem(13);
    border-radius: rem(10);
    gap: rem(10);
    &.is-loading {
      pointer-events: none;
      &::before {
        content: '';
        @include absolute;
        background-color: rgba($white, .5);
        z-index: 2;
      }
      @include loader {
        z-index: 3;
      }
    }
    @include mobile {
      align-items: center;
    }
    @include tablet{
      align-items: center;
      justify-content: space-between;
    }
  }
  .accessoire-image{
    width: 30%;
    @include tablet {
      flex-shrink: 0;
      width: 20%;
    }
    img {
      object-fit: contain;
      width: 100%;
      height: auto;
    }
  }
  .accessoire-container{
    width: 70%;
    @include tablet{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: rem(10);
      width: 80%;
    }
  }
  .accessoire-error {
    margin-top: rem(10);
    font-size: rem(12);
    color: $color-error;
  }
  .accessoire-content{
    width: 65%;
    @include mobile{
      width: 100%;
      margin-bottom: rem(17);
    }
  }
  .accessoire-title{
    font-weight: 700;
    color: $black;
    @include mobile{
      font-size: rem(14);
    }
  }
  .accessoire-description{
    font-size: rem(14);
  }
  .accessoire-actions-price{
    text-align: right;
    @include mobile{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: rem(10);
    }
  }
  .accessoire-price{
    font-weight: 700;
    color: $black;
    @include mobile{
      width: 60%;
      text-align: left;
    }
    @include tablet{
      margin-bottom: rem(6);
    }
  }
  .accessoire-actions{
    @include mobile{
      width: 40%;
    }
  }
  .accessoires-button{
    @include resetBtn;
    position: relative;
    @include cta($white, $color-second) {
      white-space: nowrap;
      @include mobile{
        width: rem(50);
        height: rem(50);
        padding: rem(5) rem(10);
      }
      @include desktop {
        font-size: rem(14);
      }
    }
    .ico {
      width: rem(28);
      height: rem(28);
      line-height: rem(28);
      color: $white;
      vertical-align: middle;
      font-size: rem(28);
    }
    &.is-loading {
      padding-right: rem(50);
      transition: padding .2s;
      @include loader($white, .75) {
        left: auto;
        right: 0;
      }
    }
  }
  .cart-accessoire-more-action{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: rem(20);
  }
  .cart-accessoire-more-btn{
    @include resetBtn;
    color: $blue;
  }
  .cart-accessoire-more-btn{
    .ico {
      line-height: rem(8);
      color: $blue;
      vertical-align: middle;
      font-size: rem(8);
    }
  }
  .cart-accessoire-more-btn--arow-up{
    .ico {
      transform: rotate(180deg);
      margin-left: rem(10);
    }
  }
</style>